module.exports = __webpack_public_path__ + "img/img23.bc93e231.png";